import React from 'react';
import { baseCss } from '../css';

const Checkbox = ({ active, onClick, disabled = 0 }) => (
    <div
        className={`checkbox ${active ? 'active' : ''} ${disabled ? 'disabled' : ''}`} style={{ ...baseCss.primaryBorder, ...(active && baseCss.primaryBackground) }}
        onClick={onClick}
    >
        <div></div>
    </div>
)

export default Checkbox